// extracted by mini-css-extract-plugin
module.exports = {"count":"NotificationBell_count__9fIy2","countText":"NotificationBell_countText__Oil0D"};